import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-areas:
      'area1 area1 area2 area2 area4 area4 area5 area5 area7 area7'
      'area1 area1 area3 area3 area4 area4 area6 area6 area7 area7'
      'area8 area8 area8 area8 area8 area9 area9 area9 area9 area9';
  grid-template-columns: 100px 100px 100px 100px 100px 100px 100px 100px 100px 100px;
  background-color: var(--canvas-background);
  min-height: 0;
  min-width: 0;
  overflow-x: auto;

  @media (min-width: 1200px){
    grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;
  }

`;

interface IQuadrantDiv{
  area: string;
  height: string; 
  background: { r: number; g: number; b: number} | null
}

export const Quadrant = styled.div<IQuadrantDiv>`
  background-color: var(--canvas-color);
  grid-area: ${(props) => props.area ?? ""};
  height: ${(props) => props.height ?? ""};
  font-size: 16px;
  border: 1px solid var(--panel-body);
  padding: 5px 5px 0 5px;
  border-radius: 10px;
`;

export const Header = styled.div<{ colorItems: string }>`
  height: 30px;
  margin: 0 4px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  color: ${(props) => props.colorItems ?? ""};
  justify-content: space-between;
  span{
    margin-left: 5px;
  }
`;

export const HeaderDivisor = styled.div`
  display: flex: 
`;

export const Content = styled.div`
  height: calc(100% - 30px);
  overflow-x: auto;
  padding-top: 15px;
`;



